module.exports = __webpack_public_path__ + "img/qy.ae4f2a60.png";